module.exports = __webpack_public_path__ + "static/img/cp_icon_B05.6234bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B05.png
// module id = nDOU
// module chunks = 1